module.exports = __webpack_public_path__ + "img/HK@2x.91e54f6c.png";